import { Box, Typography, useTheme } from "@mui/material";

const TotalPaidAmountDisplay = ({ totalPaidAmount }) => {
  const theme = useTheme();

  return (
    <Box
      gridColumn="span 4"
      gridRow="span 1"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      marginTop={1}
      marginBottom={3}
      sx={{
        backgroundColor: theme.palette.background.alt,
        borderRadius: "1.5rem",
        padding: "1rem",
      }}
    >
      <Typography variant="h5" component="div">
        Total Montant Payé
      </Typography>

      <Typography variant="h3" component="div" color="secondary">
        {totalPaidAmount} CFA
      </Typography>
    </Box>
  );
};

export default TotalPaidAmountDisplay;